import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.staging.seek.com',
    clientDomain: 'sg.employer.staging.seek.com',
    clientId: 'UwPWgnhk4umacgF26W0H1Caqr7ebihWK',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://www.jobstreet.com/about-us/contact-us-singapore/',
    },
    siteName: siteNames.employer.seek.sg,
    zone: getZoneFromSite(siteNames.employer.seek.sg),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=sg_employer_staging_seek_com.js.map